var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.941,37.25c-2.188-2.189-5.108-3.395-8.222-3.395c-3.114,0-6.034,1.206-8.223,3.395l-9.303,9.303 c0,0-0.001,0.001-0.001,0.001s-0.001,0.001-0.001,0.001l-9.304,9.303c-4.534,4.533-4.534,11.911,0,16.444 c2.188,2.189,5.109,3.395,8.222,3.395c3.114,0,6.034-1.205,8.222-3.395l18.609-18.609C75.476,49.16,75.476,41.783,70.941,37.25z  M49.504,69.475c-1.434,1.434-3.349,2.223-5.394,2.223c-2.045,0-3.96-0.789-5.394-2.223c-2.974-2.975-2.974-7.813,0-10.788 l7.891-7.891l10.788,10.788L49.504,69.475z M68.113,50.865l-7.891,7.891L49.435,47.968l7.891-7.89 c1.434-1.433,3.349-2.223,5.395-2.223c2.045,0,3.96,0.79,5.394,2.223c1.433,1.433,2.223,3.349,2.223,5.394 C70.336,47.517,69.546,49.432,68.113,50.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.515,34.692c0-5.493-4.468-9.961-9.961-9.961s-9.961,4.468-9.961,9.961s4.468,9.961,9.961,9.961 S48.515,40.185,48.515,34.692z M38.554,28.731c2.585,0,4.784,1.656,5.608,3.961H32.946C33.77,30.387,35.969,28.731,38.554,28.731z  M32.946,36.692h11.217c-0.825,2.305-3.024,3.961-5.608,3.961S33.77,38.997,32.946,36.692z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.9058a3332e60f52cb2bd464b71764407.svg";
export { ForwardRef as ReactComponent };